import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import L3pWbnbUniIcon from '../../../../../../../assets/images/L3P_WBNB.png';
import * as l3pWbnbUniStakeActions from '../../../../../../../actions/l3p-wbnb-uni-stake-actions';
import Success from '../../../../../../../components/Stake/frame/success';
import BN from 'bignumber.js';
import { toPowerOf } from '../../../../../../../blockchain/config';

const StakeSuccess = () => {
  const dispatch = useDispatch();
  const { id, amount } = useSelector((state) => state.L3PWBNBUNIstake.stake);

  const claimingToken = `${new BN(amount).div(toPowerOf).toString()} L3P/WBNB`;

  const description = `Congrats, you are now earning daily staking rewards! You may unstake your tokens at any time.`;

  return (
    <>
      <Header icon={L3pWbnbUniIcon} title='L3P/WBNB-Staking' />
      <Success
        title='You Are Staking:'
        token={claimingToken}
        txId={id}
        doneClick={() => dispatch(l3pWbnbUniStakeActions.stakeReset())}
        description={description}
      />
    </>
  );
};

export default StakeSuccess;
